import computed from './attrs/computed'
import created from './attrs/created'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'

export default {
    name: 'ProfessionalFinder',
    computed,
    created,
    data,
    methods,
    mounted
}
